import { useMemo } from "react";
import { useSdk } from "../../contexts/services/hooks/use-services-context";
import type { MailFolder } from "../../managers/dataManager/graph/types/graph";
import type { Mail, SmartLabel } from "../../managers/mail/types/mail";

export type MailLists = {
    getGeneralMails: (
        mailFolder: MailFolder,
        from: number,
        top: number,
    ) => Promise<Mail[]>;
    getSmartLabelMails: (
        label: SmartLabel,
        from: number,
        top: number,
    ) => Promise<Mail[]>;
    getCustomViewMails: (
        customViewId: string,
        from: number,
        top: number,
    ) => Promise<Mail[]>;
};

/**
 * Pages de listes de mails ; les changements arrivent par `mail-updated`, `mail-deleted`,
 * `mails-new-mails` et `custom-view-list-updated`.
 */
export function useMailLists(): MailLists {
    const { mailManager } = useSdk();

    return useMemo<MailLists>(
        () => ({
            getGeneralMails: (...args) => mailManager.getGeneralMails(...args),
            getSmartLabelMails: (...args) =>
                mailManager.getSmartLabelMails(...args),
            getCustomViewMails: (...args) =>
                mailManager.getCustomViewMails(...args),
        }),
        [mailManager],
    );
}
